<template>
    <div style="margin:10px 0" class="grace-rows">
        <el-checkbox
        style="margin-right:20px"
            :indeterminate="isIndeterminate"
            v-model="checkAll"
            @change="handleCheckAllChange"
            >全选</el-checkbox
        >
        <!-- <div style="margin: 15px 0"></div> -->
        <el-checkbox-group
            v-model="checkedItem"
            @change="handleCheckedItemChange"
        >
            <el-checkbox v-for="item in columns" :label="item.label" :key="item.label">{{
                item.label
            }}</el-checkbox>
        </el-checkbox-group>
    </div>
</template>
<script>
export default {
    data() {
        return {
            checkAll: false,
            isIndeterminate: false,
            checkedItem:this.checkedItems
        };
    },
    computed: {
        itemOptions(){
            let arr = this.columns.map(item=>{
                return item.label;
            })
            return arr;
        }
    },
    props: {
        columns: {
            type: Array,
            default: []
        },
        checkedItems:{
            type: Array,
            default: []
        },
    },
    methods: {
        handleCheckAllChange(val) {
            this.checkedItem = val ? this.itemOptions : [];
            this.isIndeterminate = false;
            this.$parent.changeColumns(this.checkedItem)
        },
        handleCheckedItemChange(value) {
            let checkedCount = value.length;
            this.checkAll = checkedCount === this.columns.length;
            this.isIndeterminate =
                checkedCount > 0 && checkedCount < this.columns.length;
            this.$parent.changeColumns(this.checkedItem)
        },
    },
};
</script>


// WEBPACK FOOTER //
// src/components/Individuation.vue